var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import FilterPanel from '../../components/common/filterPanel';
import BOMDataTable from '../../components/requirements/bomDataTable';
import { getBomDetails, getBomFilterSectionData, getApprovalsBOMCount } from '../../services/projectService';
import { convertSelFilterValToLuObj } from '../../utils/commonUtil';
import { useDispatch, useSelector } from 'react-redux';
import { setKeywordSearchStr } from '../../context/reducers/userReducer';
import { useNavigate } from 'react-router-dom';
import FloatingOptions from "../../components/common/floatingOptions";
import { UserActivity } from "../../config/BVConstants";
import commonService from "../../services/CommonService";
export const Services = () => {
    var _a, _b, _c, _d;
    const [selCountryTerritoryList, setSelCountryTerritoryList] = useState([]);
    const [selProductTypeList, setSelProductTypeList] = useState([]);
    const [selServiceTypeList, setSelServiceTypeList] = useState([]);
    const [selTechnologyTypeList, setSelTechnologyTypeList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [bomDataList, setBomDataList] = useState([]);
    const [strSearchBoxText, setStrSearchBoxText] = useState('');
    const [totalBOMCount, setTotalBOMCount] = useState(0);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const applicationData = useSelector((state) => state.applicationData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 4)) != undefined;
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (!((_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.boolRequirementsRequirementPage) || !boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        else if ((_c = (_b = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _b === void 0 ? void 0 : _b.userLoginDetails) === null || _c === void 0 ? void 0 : _c.strUserEmailId) {
            commonService
                .logUserActivity((_e = (_d = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _d === void 0 ? void 0 : _d.userLoginDetails) === null || _e === void 0 ? void 0 : _e.strUserEmailId, UserActivity.CP__Services_Visited);
        }
        // Fetch data whenever pagination or filter parameters change
        fetchData(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize, selCountryTerritoryList, selProductTypeList, selServiceTypeList, selTechnologyTypeList, strSearchBoxText]);
    useEffect(() => {
        if (applicationData.keywordSearchStr) {
            handleClearBOMAllAppliedFilters();
            setStrSearchBoxText(applicationData.keywordSearchStr);
            dispatch(setKeywordSearchStr(''));
        }
    }, [applicationData.keywordSearchStr]);
    const fetchData = (page, pageSize) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        setIsLoading(true);
        const firstPage = page == 1 ? page : ((page * 10) - 10) + 1;
        const lastPage = page == 1 ? pageSize : (page * 10);
        const searchTblService = {
            lstLuCountry: convertSelFilterValToLuObj(selCountryTerritoryList),
            lstLuTechnologyType: convertSelFilterValToLuObj(selTechnologyTypeList),
            lstLuProductType: convertSelFilterValToLuObj(selProductTypeList),
            lstLuServiceCode: convertSelFilterValToLuObj(selServiceTypeList),
            strSearchBoxText: strSearchBoxText,
            intFirstPage: firstPage,
            intPageSize: lastPage
        };
        try {
            const countResponse = yield getApprovalsBOMCount(JSON.stringify(searchTblService));
            setTotalBOMCount(countResponse);
            const response = yield getBomDetails(JSON.stringify(searchTblService));
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Services_Search);
            setBomDataList(response);
            setPagination(prev => (Object.assign(Object.assign({}, prev), { total: countResponse })));
        }
        catch (error) {
            console.error('Failed to fetch data:', error);
        }
        finally {
            setIsLoading(false);
        }
    });
    const handleTableChange = (pagination) => {
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: pagination.current, pageSize: pagination.pageSize })));
    };
    const handleClearBOMAllAppliedFilters = () => {
        setSelCountryTerritoryList([]);
        setSelProductTypeList([]);
        setSelServiceTypeList([]);
        setSelTechnologyTypeList([]);
        setStrSearchBoxText('');
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: 1 })));
    };
    const bomFilterSectionData = getBomFilterSectionData(applicationData, selCountryTerritoryList, (val) => setSelCountryTerritoryList(val), selServiceTypeList, (val) => setSelServiceTypeList(val), selProductTypeList, (val) => setSelProductTypeList(val), selTechnologyTypeList, (val) => setSelTechnologyTypeList(val), handleClearBOMAllAppliedFilters);
    return (_jsxs(_Fragment, { children: [width <= 1150 &&
                _jsx(FloatingOptions, { data: bomFilterSectionData }), _jsxs(Row, { gutter: [16, 16], children: [width > 1150 &&
                        _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 6, xl: 5, children: _jsx(FilterPanel, { data: bomFilterSectionData }) }), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: (width <= 1150) ? 24 : 18, xl: (width <= 1150) ? 24 : 19, children: _jsx(BOMDataTable, { data: bomDataList, loading: isLoading, pagination: pagination, onChange: handleTableChange }) })] })] }));
};
export default Services;
